'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const StyledOrderedList = styled__default["default"].ol.withConfig({
  componentId: "sc-1546jsb-0"
})(["padding-inline-start:4rem;margin:0;display:flex;gap:2rem;flex-direction:column;"]);
const StyledOrderedListItem = styled__default["default"].li.withConfig({
  componentId: "sc-1546jsb-1"
})(["counter-increment:list-item;display:flex;&::before{content:counter(list-item);line-height:1;min-width:2.5rem;width:2.5rem;height:2.5rem;display:flex;align-items:center;justify-content:center;margin:0 1.5rem 0 -4rem;padding:0.625rem;border:0.1875rem solid ", ";border-radius:1.625rem;color:", ";box-sizing:border-box;text-align:center;font-family:", ";font-weight:bold;}&::marker{content:'';}"], props => props.s.borderColor, props => props.s.color, props => props.s.fontFamily);
const StyledStepSpan = styled__default["default"].span.withConfig({
  componentId: "sc-1546jsb-2"
})(["display:block;margin:0.5rem 0 0;"]);
const StyledLinkContainer = styled__default["default"].div.withConfig({
  componentId: "sc-1546jsb-3"
})(["margin-top:1rem;display:flex;flex-wrap:wrap;gap:16px;"]);

exports.StyledLinkContainer = StyledLinkContainer;
exports.StyledOrderedList = StyledOrderedList;
exports.StyledOrderedListItem = StyledOrderedListItem;
exports.StyledStepSpan = StyledStepSpan;
